/**
 * Formatos padronizados (pt-BR) para o que o frontend formata: datas vindas da API em
 * ISO (AAAA-MM-DD) viram DD/MM/AAAA. Números prontos (métricas, cartões) já vêm
 * formatados do backend (`apps.core.formatos`); tabelas usam `TabelaDados`.
 */

/** `"2026-10-02"` (ou `"2026-10-02T10:00:00"`) → `"02/10/2026"`; outro texto passa igual. */
export function formatarData(valor: string | null | undefined): string {
  if (!valor) return '';
  const achado = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor);
  return achado ? `${achado[3]}/${achado[2]}/${achado[1]}` : valor;
}

/** `"2026-10-05T08:25"` → `"05/10/2026 08:25"`; sem hora, só a data. */
export function formatarDataHora(valor: string | null | undefined): string {
  if (!valor) return '';
  const achado = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(valor);
  return achado
    ? `${achado[3]}/${achado[2]}/${achado[1]} ${achado[4]}:${achado[5]}`
    : formatarData(valor);
}
